import { resolveApiAssetUrl } from '@util'
import { Box, Layer, Text } from 'grommet'
import { useDispatch } from 'react-redux'
import { ModalHeader } from '../../../../components/common'
import { useAppSelector } from '../../../../store/hooks'
import { hideViewImagingResultFile } from '../../../../store/slicers/ModalSlicer'

const ViewImagingResults = () => {
  const dispatch = useDispatch()
  const { show, defaultData } = useAppSelector(state => state.modal.viewImagingResultFile)

  if (!show || !defaultData) return null

  const { url, filename, content_type, byte_size } = defaultData
  const resolvedUrl = resolveApiAssetUrl(url)
  const isPDF = content_type === 'application/pdf' || filename.toLowerCase().endsWith('.pdf')
  const isImage = content_type.startsWith('image/')

  const onClose = () => dispatch(hideViewImagingResultFile())

  // Helper to lowercase the file extension
  // const getFilenameWithLowercaseExt = (name: string) => {
  //   const lastDot = name.lastIndexOf('.')
  //   if (lastDot === -1) return name
  //   return name.slice(0, lastDot) + name.slice(lastDot).toLowerCase()
  // }

  // Helper to capitalize the base name and lowercase the extension
  const getFilenameCapitalizedWithLowercaseExt = (name: string) => {
    const lastDot = name.lastIndexOf('.')
    if (lastDot === -1) return name.charAt(0).toUpperCase() + name.slice(1)
    const base = name.slice(0, lastDot)
    const ext = name.slice(lastDot).toLowerCase()
    // Capitalize each word in the base
    const baseCapitalized = base.replace(/\b\w/g, c => c.toUpperCase())
    return baseCapitalized + ext
  }

  return (
    <Layer modal onEsc={onClose} position="center" style={{ borderColor: '#999999 !important', borderRadius: '15px' }}>
      <Box style={{ borderRadius: '2em', maxHeight: '90vh', overflowY: 'auto', width: '81vw' }}>
        <ModalHeader onClose={onClose} title="Imaging Result Preview" />

        <Box pad={{ horizontal: 'large', vertical: 'medium' }}>
          <Text size="16px" weight={500}>
            {getFilenameCapitalizedWithLowercaseExt(filename)}
          </Text>
          <Text color="#909090" size="14px">
            {(byte_size / (1024 * 1024)).toFixed(2)} MB
          </Text>
          <Box margin={{ bottom: 'medium', top: 'medium' }}>
            {isPDF ? (
              <iframe height="600px" src={resolvedUrl} style={{ border: 'none' }} title={filename} width="100%" />
            ) : isImage ? (
              <img
                alt={filename}
                src={resolvedUrl}
                style={{ display: 'block', margin: '0 auto', maxHeight: '600px', maxWidth: '100%' }}
              />
            ) : (
              <Text>Cannot preview this file type.</Text>
            )}
          </Box>
        </Box>
      </Box>
    </Layer>
  )
}

export default ViewImagingResults
